/* Strip "#" prefix from tag names rendered by Handlebars */
(function () {
    const tagElements = document.querySelectorAll('[data-extract-tag]');
    if (!tagElements.length) return;

    tagElements.forEach(function (element) {
        const tagName = (element.textContent || '').trim();
        if (!tagName || tagName.charAt(0) !== '#') return;
        element.textContent = tagName.slice(1);
    });
})();

/* Normalize series links (/series/<slug>/ without hash-series-) */
(function () {
    const seriesLinks = document.querySelectorAll('[data-series-link]');
    if (!seriesLinks.length) return;

    seriesLinks.forEach(function (link) {
        const seriesSlug = (link.getAttribute('data-series-slug') || '').trim();
        if (!seriesSlug) return;

        const cleanSlug = seriesSlug.replace(/^hash-series-/, '');
        link.setAttribute('href', '/series/' + cleanSlug + '/');
    });
})();
